import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';

export const standardDeviationDescription: CalculatorDescription = {
  id: CalculatorId.STANDARD_DEVIATION,
  title: 'Standard deviation calculator',
  metaTitle: 'Standard Deviation Calculator - Measure Data Dispersion',
  description: 'Calculate the standard deviation of your dataset to measure how spread out the values are from the mean.',
  metaDescription: 'Free online standard deviation calculator. Measure data dispersion with our easy-to-use statistical tool. Calculate population and sample standard deviation.',
  howTo: {
    title: 'How to calculate standard deviation',
    steps: [
      'Enter your numeric data directly into the data table or upload a CSV file',
      'Use the "Select Data Column" control to choose which column of data to analyze',
      'The calculator will automatically compute both population and sample standard deviation',
      'View the mean and variance values in the results',
      'Examine the visualization to understand the data distribution and spread'
    ],
    graphic: {
      description: 'Visual representation of standard deviation calculation'
    }
  },
  examples: [
    {
      title: 'Analyzing test score variation',
      description: 'Measuring the spread of student performance',
      dataDescription: 'Test scores from a class of 25 students',
      insights: [
        'The standard deviation is 12.3, indicating moderate spread',
        'About 68% of scores fall within ±12.3 points of the mean (78.2)',
        'Lower standard deviation would indicate more consistent performance',
        'Higher standard deviation would show greater performance differences'
      ],
      data: TableDataJSON.from({
        columns: [
          { 
            id: 'scores',
            name: 'Test Scores', 
            values: ['45', '55', '60', '65', '65', '70', '70', '72', '75', '75', '75', '78', '80', '80', '82', '85', '85', '85', '88', '90', '90', '92', '95', '98', '100'] 
          }
        ]
      })
    }
  ],
  relatedCalculators: [
    CalculatorId.VARIANCE,
    CalculatorId.MEAN,
    CalculatorId.RANGE
  ]
}; 